if (!customElements.get("slideshow-video-media")) {
class SlideshowVideoMedia extends HTMLElement {
    constructor() {
        super();
        this.videoOptions = JSON.parse(this.dataset.videoOptions || '{}');
        this._abortController = new AbortController();
        this.currentStoreName = window.Shopify.shop;
    }

    connectedCallback() {
        this.videoOptions.showCoverImage ? this.addCoverImage() : this.setupInViewObserver();
        this.videoOptions.showPlayButton ? this.addControlButtons() : this.setupInViewObserver();
    }

    setupInViewObserver() {
        this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => entry.isIntersecting ? this.play() : this.pause());
        });

        this._observer.observe(this);
    }

    setupPlayButtonEvent() {
        if (this.playButton) {
            this.playButton.addEventListener(
                "click",
                () => {
                    this.setAttribute("media-state", "manual-played");
                    this.play();
                    if (!this._observer) this.setupInViewObserver();
                },
            );
        }
        if (this.pauseButton) {
            this.pauseButton.addEventListener(
                "click",
                () => {
                    this.setAttribute("media-state", "manual-paused");
                    this.pause()
                },
            );
        }
    }

    addCoverImage() {
        this.coverImage = document.createElement("div");
        this.coverImage.classList.add("cover-image__container");
        Object.assign(this.coverImage.style, {
            zIndex: "0",
            position: "absolute",
            right: "0",
            bottom: "0",
            top: "0",
            left: "0",
            borderRadius: ".6rem",
            overflow: "hidden"
        });
        this.coverImage.innerHTML = this.getCoverImageMarkup();
        this.appendChild(this.coverImage);
    }

    getImageUrl() {
        ["coverDesktopImage", "coverMobileImage"].forEach(type => {
            this.videoOptions[type] = this.videoOptions[type]
                ? `//${this.currentStoreName}/cdn/shop/${this.videoOptions[type]}`
                : '';
        });
    }

    getCoverImageMarkup() {
        this.getImageUrl();
        const { coverDesktopImage, coverMobileImage } = this.videoOptions;
        if (coverDesktopImage || coverMobileImage) {
            return `
          <picture>
            ${coverDesktopImage ? `<source media="(min-width: 451px)" srcset="${coverDesktopImage}">` : ''}
            ${coverMobileImage ? `<source media="(max-width: 450px)" srcset="${coverMobileImage}">` : ''}
            <img src="${coverMobileImage || coverDesktopImage}" alt="video cover image" style="object-fit:cover; height:100%;">
          </picture>`;
        } else {
            return `
          <svg viewBox="0 0 32 32" width="288" height="288">
            <path fill="#e0c45c" d="M28 5H4a3 3 0 0 0-3 3v15a1 1 0 0 0 1.74.67l8.15-9.08 5.6 8.09a1 1 0 0 0 1.43.22l6-4.59 5.38 5.47a1 1 0 0 0 1.7-.68V8a3 3 0 0 0-3-3"/>
            <path fill="#85203b" d="m30.71 22.4-6-6.1a1 1 0 0 0-1.32-.09l-6.68 5.13a1 1 0 0 0-.21 1.36l2.68 3.87A1 1 0 0 0 20 27h8a3 3 0 0 0 3-3v-.9a1 1 0 0 0-.29-.7"/>
            <path fill="#85203b" d="m20.82 25.43-9-13a1 1 0 0 0-1.57-.1l-9 10A1 1 0 0 0 1 23v1a3 3 0 0 0 3 3h16a1 1 0 0 0 .82-1.57"/>
            <circle cx="20" cy="12" r="2" fill="#fff98c"/>
          </svg>`;
        }
    }

    addControlButtons() {
        this.addPlayButton();
        this.addPauseButton();
        this.setupPlayButtonEvent();
    }

    removeControlButtons() {
        this.removePlayButton();
        this.removePauseButton();
    }

    addPlayButton() {
        this.playButton = document.createElement("div");
        this.playButton.classList.add("play-button__container");
        Object.assign(this.playButton.style, {
            zIndex: "9999",
            position: "absolute",
            right: "1rem",
            bottom: "1rem",
            cursor: "pointer",
            display: "block"
        });
        this.playButton.innerHTML = `
        <svg part="play-button" fill="none" width="48" height="48" viewBox="0 0 48 48">
          <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="#fff"/>
          <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="#313131"/>
          <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="#000" stroke-opacity=".3"/>
        </svg>`;
        this.appendChild(this.playButton);
    }

    addPauseButton() {
        this.pauseButton = document.createElement("div");
        this.pauseButton.classList.add("pause-button__container");
        Object.assign(this.pauseButton.style, {
            zIndex: "9999",
            position: "absolute",
            right: "1rem",
            bottom: "1rem",
            cursor: "pointer",
            display: "none"
        });
        this.pauseButton.innerHTML = `
        <svg part="pause-button" fill="#fff" height="48" width="48" viewBox="-10.24 -10.24 532.48 532.48" stroke="#fff">
          <rect x="-10.24" y="-10.24" width="532.48" height="532.48" rx="266.24" fill="#313131" stroke="none"/>
          <g stroke-linecap="round" stroke-linejoin="round" />
          <path  d="M256 0C114.617 0 0 114.615 0 256s114.617 256 256 256 256-114.615 256-256S397.383 0 256 0zm-32 320c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16V192c0-8.836 7.164-16 16-16h32c8.836 0 16 7.164 16 16zm128 0c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16V192c0-8.836 7.164-16 16-16h32c8.836 0 16 7.164 16 16z"/>
        </svg>`;
        this.appendChild(this.pauseButton);
    }

    showPlayButton() {
        this.playButton.style.display = "block";
        this.pauseButton.style.display = "none";
    }
    
    showPauseButton() {
        this.playButton.style.display = "none";
        this.pauseButton.style.display = "block";
    }

    removePlayButton() {
        if (this.playButton) this.playButton.remove();
    }

    removePauseButton() {
        if (this.pauseButton) this.pauseButton.remove();
    }

    removeCoverImage() {
        if (this.coverImage) this.coverImage.remove();
    }

    async play() {
        if (this.getMediaState === "manual-paused") return;
        if (this.coverImage) this.removeCoverImage();

        if (!this.playing) {
            await this._getVideoPlayer();
            if (this.getAttribute("host") === "youtube" && typeof this.videoPlayer.playVideo === "function") {
                this.videoPlayer.playVideo();
                this.setAttribute("playing", "");
                this.showPauseButton();
            } else if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
                this.videoPlayer.play();
                this.setAttribute("playing", "");
                this.showPauseButton();
            }
        }
    }

    async pause() {
        if (this.playing) {
            await this._getVideoPlayer();

            if (this.getAttribute("host") === "youtube" && typeof this.videoPlayer.pauseVideo === "function") {
                this.videoPlayer.pauseVideo();
                this.removeAttribute("playing");
                this.showPlayButton();
            } else if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
                this.videoPlayer.pause();
                this.removeAttribute("playing");
                this.showPlayButton();
            }
        }
    }

    async _getVideoPlayer() {
        if (this.videoPlayer) return this.videoPlayer;

        const target = this.querySelector("iframe") || this.querySelector("video");
        if (this.hasAttribute("host")) {
            this.setAttribute("loaded", "");
            if (this.getAttribute("host") === "youtube") {
                this.videoPlayer = await this._setupYouTubePlayer(target);
            } else {
                this.videoPlayer = target;
            }
        } else {
            this.videoPlayer = target;
        }
        return this.videoPlayer;
    }

    async _setupYouTubePlayer(target) {
        await this._loadYouTubeAPI();
        return new YT.Player(target, {
            events: {
                "onReady": () => {
                    this.videoPlayer.playVideo();
                    this.setAttribute("playing", "");
                    this.showPauseButton();
                },
                "onStateChange": (event) => {
                    if (event.data === YT.PlayerState.PLAYING) this.setAttribute("playing", "");
                    else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) this.removeAttribute("playing");
                }
            }
        });
    }

    async _loadYouTubeAPI() {
        if (!window.YT) {
            const script = document.createElement("script");
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            return new Promise(resolve => { window.onYouTubeIframeAPIReady = resolve; });
        }
    }

    disconnectedCallback() {
        this._abortController.abort();
        if (this._observer) this._observer.disconnect();
    }

    get playing() {
        return this.hasAttribute("playing");
    }

    get getMediaState() {
        return this.getAttribute("media-state");
    }
}

customElements.define("slideshow-video-media", SlideshowVideoMedia);
}
